import { instance } from 'services';
import { IFindFnReturn, IQueryParams } from 'services/types.d';

import { IReadOnlyResource } from './types.d';

export const CompanyTypeResources = {
  findAll: (params?: IQueryParams): Promise<IFindFnReturn<IReadOnlyResource>> =>
    instance.get('/company-type/', { params }),
};
